import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function ProjectRadioSetting({
  selectedValue,
  setSelectedValue,
}) {
  const handleChange = (event) => {
    setSelectedValue(event.target.value); // Update the state with the selected value
  };
  return (
    <FormControl>
      <FormLabel
        id="demo-row-radio-buttons-group-label"
        sx={{ color: "black", fontSize: "1rem", marginBottom: 1 }}
      >
        Send Reminder To
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={selectedValue} // Bind the value to the state
        onChange={handleChange}
      >
        <FormControlLabel
          value="1"
          control={
            <Radio
              sx={{
                color: "gray",
                "&.Mui-checked": {
                  color: "#1d82f5",
                },
              }}
            />
          }
          label="Administrators"
        />
        <FormControlLabel
          value="2"
          control={
            <Radio
              sx={{
                color: "gray",
                "&.Mui-checked": {
                  color: "#1d82f5",
                },
              }}
            />
          }
          label="Project Members"
        />
        <FormControlLabel
          value="3"
          control={
            <Radio
              sx={{
                color: "gray",
                "&.Mui-checked": {
                  color: "#1d82f5",
                },
              }}
            />
          }
          label="All"
        />
      </RadioGroup>
    </FormControl>
  );
}
